import { turnSelectors } from '../selectors';
// ---- parent imports ----

function _isLeased(warehouse, currentTurn) {
	const warehouseHasStarted = warehouse.startTurn <= currentTurn;
	const warehouseHasNotEnded =
		warehouse.endTurn === null || warehouse.endTurn === currentTurn;
	return warehouseHasStarted && warehouseHasNotEnded;
}

export function getAllWarehouses(state) {
	return state.warehouses.allWarehouses;
}

export function getLeasedWarehouses(state) {
	return state.warehouses.leasedWarehouses;
}

export function getWarehouse(state, warehouseId) {
	return getAllWarehouses(state)[warehouseId - 1];
}

export function hasLeasedWarehouse(state) {
	return getLeasedWarehouse(state) !== undefined;
}

export function getLeasedWarehouse(state) {	
	const currentTurn = turnSelectors.getTurnNum(state);

	const allWarehouseEverLeased = getLeasedWarehouses(state);
	const currentlyLeasedWarehouse = 
		allWarehouseEverLeased.find((warehouse) => _isLeased(warehouse, currentTurn));

	return currentlyLeasedWarehouse;
}

export function hasExtraCapacity(state) {
	return hasLeasedWarehouse(state);
}

export function getExtraCapacity(state) {
	if (!hasExtraCapacity(state))
		return 0;

	return getLeasedWarehouse(state).extraFurnitureCapacity;
}

export function getWarehouseRent(state) {
	const warehouse = getLeasedWarehouse(state);
	
	if (!warehouse) {
		return 0;
	}
	else {
		return warehouse.price;
	}
}

export function getNextMonthWarehouseRent(state) {
	const allWarehouseEverLeased = getLeasedWarehouses(state);
	const nextMonthLeasedWarehouses = 
		allWarehouseEverLeased.filter((warehouse) => warehouse.endTurn === null );

	const totalRent = nextMonthLeasedWarehouses.reduce((total, warehouse) => {
		return total + warehouse.price;
	}, 0);

	return totalRent;
}

export function canLease(state) {
	const currentTurn = turnSelectors.getTurnNum(state);

	const activeWarehouses = getLeasedWarehouses(state)
		.find((entry) => entry.startTurn > currentTurn || entry.endTurn === null);
	
	const noActiveWarehouses = (activeWarehouses === undefined);

	return noActiveWarehouses;
}

export function hasWarehouseUnleasedThisTurn(state) {
	const currentTurn = turnSelectors.getTurnNum(state);
	const warehouse = getLeasedWarehouses(state)
		.find((entry) => entry.endTurn === currentTurn);
	return warehouse !== undefined;
}

export function getWarehousesAvailableForRent(state) {
	const all = getAllWarehouses(state);
	const allWarehouseEverLeased = getLeasedWarehouses(state);
	
	return all.filter((warehouse) => {
		const isNotCurrentlyLeased = allWarehouseEverLeased.find(
			(leasedWarehouse) => (
				leasedWarehouse.warehouseId === warehouse.id
				&& leasedWarehouse.endTurn === null
			)
		) === undefined;

		return isNotCurrentlyLeased;
	});
}
